// Funciones que se muestran solo a cierto PERFIL de negocio (negocios.rubro,
// elegido en el onboarding o en Configuración). Ver utils/onboarding.js RUBROS.

// Agencias de viajes: destinos y servicios en la ficha del cliente.
export const esViajes = (negocio) => negocio?.rubro === 'viajes' || negocio?.modo_viajes === true;

// Distribuidores (pollo, carnes, alimentos): venden por libra.
export const esDistribuidor = (negocio) => negocio?.rubro === 'distribuidor';

// Categorías con las que arranca un distribuidor nuevo (si no tiene ninguna).
export const CATEGORIAS_DISTRIBUIDOR = [
  { nombre: 'Pollo', prefijo: 'POL', icono: '🍗' },
  { nombre: 'Embutidos', prefijo: 'EMB', icono: '🥩' },
  { nombre: 'Huevos', prefijo: 'HUE', icono: '🥚' },
  { nombre: 'Otros productos', prefijo: 'OTR', icono: '📦' },
];
